'use strict';
var base;

require('core-js/es6/function');

require('core-js/fn/array/find');

require('core-js/fn/array/find-index');

require('core-js/fn/object/keys');

require('core-js/fn/object/entries');

require('core-js/fn/object/assign');

require('core-js/fn/object/values');

require('core-js/fn/string/includes');

require('picturefill');

require('dom4');

document.head || (document.head = document.getElementsByTagName('head')[0]);

(base = window.location).origin || (base.origin = window.location.protocol + "//" + window.location.host);


/*
 * Chrome requestIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.requestIdleCallback = window.requestIdleCallback || function(cb) {
  return setTimeout((function() {
    var start;
    start = Date.now();
    return cb({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }), 1);
};


/*
 * Chrome cancelIdleCallback() shim: https://gist.github.com/paullewis/55efe5d6f05434a96c36
 */

window.cancelIdleCallback = window.cancelIdleCallback || function(id) {
  return clearTimeout(id);
};

